import { createElement, useState } from 'react'
import { useAuth, useView } from '@10000/react'
import { Avatar, Box, Body, Button, H4, Icon } from '../widgets'
import { Account, Billing, Organisations, Preferences, Profile, Subscription, Teams, Users } from './settingsType'
import { useBackground, useShell, useStack } from '../layout'
import { SettingsBackButton } from './'
import { isPartner } from '../../lookups'
import './Settings.scss'

export const Settings = ({ active }) => {
  const { user: { name, email, avatar, admin }, subscription } = useView('tenant')
  const { pop } = useStack()
  const { logout } = useAuth()

  useBackground().set({ active, background: null })
  useShell({ active, mode: 'authenticated hide-mobile-header', headerBackground: 'black', onLogoClick: pop })

  const [settingsIndex, setSettingsIndex] = useState(-1)
  const [mobileEditProfile, setMobileEditProfile] = useState(false)

  const settings = [
    ...(admin ? [{ title: 'Account', icon: 'User', component: Account }] : []),
    ...(admin ? [{ title: 'Subscription', icon: 'Rocket', component: Subscription }] : []),
    ...(admin ? [{ title: 'Billing', icon: 'PaymentCard', component: Billing }] : []),
    ...((admin && (isPartner(subscription)))
      ? [{ title: 'Organisations', icon: 'Company', component: Organisations }]
      : [{ title: 'Teams', icon: 'Network', component: Teams }]),
    ...(admin ? [{ title: 'Users', icon: 'Team', component: Users }] : []),
    { title: 'Preferences', icon: 'SliderSettings', component: Preferences }
  ]

  const goBackToSettingsMenu = () => {
    setSettingsIndex(-1)
    setMobileEditProfile(false)
  }

  return <Box fullWidth column>
    <Box className="settings-screen" fullWidth height="100%">
      <Box
        className={`settings-options ${(settingsIndex > -1 || (settingsIndex === -1 && mobileEditProfile)) ? 'hidden-setting' : ''}`}
        column
        container
      >
        <Box column gap={16}>
          <H4 color="black">Settings</H4>
          <SettingsBackButton mobileOnly onClick={() => pop()} />
          <Box column gap={8} alignItems="center" textAlign="center">
            <Avatar
              index={avatar}
              label={admin ? 'ADMIN' : 'TEAM LEAD'}
              labelColor="white"
              labelBackground={admin ? 'red' : 'blue'}
            />
            <Box column>
              <Body bold alt>{name}<br/></Body>
              <Body bold={false} alt={false}>{email}</Body>
            </Box>
            <Button
              className="small"
              onClick={() => {
                setSettingsIndex(-1)
                setMobileEditProfile(true)
              }}
            >
              Edit profile
            </Button>
          </Box>

          <Box height={1} background="black" fullWidth />
        </Box>
        <Box className="settings-nav-options black-scroller" column overflowY="auto">
          {settings.map(({ title, icon }, index) => <Box
            fullWidth
            gap={8}
            cursor="pointer"
            key={index}
            alignItems="center"
            onClick={() => setSettingsIndex(index)}
            className={`option ${settingsIndex === index ? 'selected-option' : ''}`}
          >
            <Icon size={24} fill={settingsIndex === index ? 'white' : 'black'} icon={icon}/>
            <Body bold={settingsIndex === index}>{title}</Body>
          </Box>)}
        </Box>
        <Box className="logout" p={16}>
          <Body underline bold alt italic style={{ cursor: 'pointer' }} onClick={logout}>Log out</Body>
        </Box>
      </Box>
      <Box fullWidth className={`settings-section ${settingsIndex === -1 && !mobileEditProfile ? 'hidden-setting' : ''}`}>
        {createElement(settingsIndex > -1 ? settings[settingsIndex].component : Profile, { goBackToSettingsMenu })}
      </Box>
    </Box>
  </Box>
}